import { getConfig } from './get-config';
/**
 * Retrieves the routes from the `window.SYDLE.app` object.
 * @returns The routes object if available, otherwise `undefined`.
 */
export function getRoutes() {
    var _a;
    return (_a = getConfig('ui-app')) === null || _a === void 0 ? void 0 : _a.routes;
}
